module.exports = __webpack_public_path__ + "static/media/mountains.ab7bc45b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/mountains.mp3
// module id = 743
// module chunks = 0